export const validationMessages = {
  checkboxGroup: {
    required: 'At least one option is required',
  },
  currency: {
    min: 'Must enter an amount greater than 0',
    required: 'Amount is required',
  },
  date: {
    format: 'Date must be in the format yyyy-MM-dd',
    required: 'Date is required',
  },
  email: {
    required: 'Email is required',
  },
  multiSelect: {
    min: 'At least one option is required',
  },
  name: {
    min: 'Name must be at least 2 characters',
    required: 'Name is required',
  },
  phone: {
    default: 'Please enter a valid phone number',
    required: 'Phone number is required',
  },
  shortSSN: {
    length: 'SSN must be exactly 4 digits',
    required: 'SSN is required',
  },
  singleSelect: {
    required: 'Option is required',
  },
  ssn: {
    length: 'SSN must be exactly 9 digits',
    required: 'SSN is required',
  },
  toggleButtonGroup: {
    required: 'Please select an option',
  },
  zip: {
    length: 'Zip code must be exactly 5 digits',
    required: 'Zip code is required',
  },
};
